module.exports = __webpack_public_path__ + "media/images/iconSocialX__accent--dark-fff3a82db6e0a4c85b3f0c6109fd9c92.png";